const HTML_CONTENT_REGEX = /<\/?[a-z][\s\S]*>/i;

const escapeHtml = (text) => (
    text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
);

// Escapes plain text and wraps it in paragraphs (a blank line starts a new
// paragraph, a single newline becomes <br />). Unlike
// normalizeRichTextContent it never passes markup through, so it is the one
// to use for plain-text fields such as a post's description.
export const convertPlainTextToHtml = (value) => {
    if (!value) {
        return '<p></p>';
    }

    const lines = value.split(/\r?\n/);
    const paragraphs = [];
    let buffer = [];

    lines.forEach((line) => {
        if (line.trim() === '') {
            if (buffer.length > 0) {
                paragraphs.push(`<p>${buffer.join('<br />')}</p>`);
                buffer = [];
            }
        } else {
            buffer.push(escapeHtml(line));
        }
    });

    if (buffer.length > 0) {
        paragraphs.push(`<p>${buffer.join('<br />')}</p>`);
    }

    return paragraphs.length > 0 ? paragraphs.join('') : '<p></p>';
};

export const normalizeRichTextContent = (value) => {
    if (!value) {
        return '<p></p>';
    }

    if (HTML_CONTENT_REGEX.test(value)) {
        return value;
    }

    return convertPlainTextToHtml(value);
};

export const extractPlainText = (value) => {
    if (!value) {
        return '';
    }

    const normalized = normalizeRichTextContent(value)
        .replace(/<\/(p|div|br|li|h[1-6])>/gi, '$&\n')
        .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, '')
        .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/&quot;/gi, '"')
        .replace(/&#39;/gi, '\'')
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>');

    return normalized
        .split('\n')
        .map((segment) => segment.trim())
        .filter(Boolean)
        .join(' ');
};

const EMBEDDED_MEDIA_REGEX = /<(img|video|audio|iframe|embed)\b/i;

export const isRichTextEmpty = (value) => {
    if (!value) {
        return true;
    }

    // Content that carries media (e.g. an image-only document) is not empty
    // even though it has no extractable text.
    if (EMBEDDED_MEDIA_REGEX.test(normalizeRichTextContent(value))) {
        return false;
    }

    return extractPlainText(value).length === 0;
};
